export const PlantItemDetailsPage = {
  locationAddressOfItemLabel: 'Location address of the item',
  reasonToRegisterToNSWLabel: 'Please tell us why you are seeking registration in NSW?',
  itemDetails: {
    boilerTypeLabel: 'Type of boiler',
    pressureVesselTypeLabel: 'Type of pressure vessel',
    liftTypeLabel: 'Type of lift',
    amusementDeviceTypeLabel: 'Type of amusement device',
    otherType: 'Other type (please describe)',
    manufacturerLabel: 'Manufacturer',
    modelNameOrNumberLabel: 'Manufacturers model name or number',
    yearOfManufactureLabel: 'Year of manufacture',
    serialNumberLabel: 'Serial number',
    locationTypeLabel: 'Is the item mobile or fixed/ installed at the location provided?',
    specificLocationLabel: 'Specific location of the item at the above address (optional)',
    uniqueIdentifierLabel: 'Your unique identifier for the item (optional)',
    liftAccessibilityLabel: 'Lift accessibility at location',
  },
  associatedDesign: {
    designedBeforeDateLabel: 'Is the plant item designed before 01 September 2001?',
    concretePlacingBoomDesignBeforeDateLabel: 'Is the plant item designed before the following dates?',
    concreatePlacingBoomDesignBeforeDateFixedLabel: 'For satellite / fixed concrete placing booms, before 13 Feb 2015',
    concreatePlacingBoomDesignBeforeDateMobileLabel:
      'For mobile / truck mounted concrete placing booms, before 1 Jan 2012',
    designRegisteredStateLabel: 'Which state is the design registered',
    designRegistrationNumberLabel: 'Design registration number',
  },
  relatedDetails: {
    amusementDevice: {
      nameOrDescriptionLabel: 'Name or description of amusement device',
      deviceClassLabel: 'Please select the class of device (in accordance with AS 3543 Part 1)',
      mobilityTypeTabel: 'Device type',
      electricalInstallationLabel: 'Does the device include an electrical installation?',
      operatingPowerLabel: 'Operating power',
      otherOperatingPowerLabel: 'Other (Please describe)',
      maxSpeedLabel: 'Designer’s maximum speed of patron',
      maxAccelerationLabel: 'Designer’s maximum acceleration',
      maxResolvingSpeedLabel: 'Designer’s max. revolving speed (if applicable)',
      maxHeightPatronLabel: 'Designer’s maximum height attained by patron',
      maxPatronSupportUnitsLabel: 'Maximum number of patron support units',
      maxAdultPatronsPerSupportLabel: 'Maximum number of adult patrons per support',
      maxChildPatronsPerSupportLabel: 'Maximum number of child patrons per support (optional)',
      minAgeUnAccompaniedPatronLabel: 'Minimum age of unaccompanied patron',
      minAgeAccompaniedPatronLabel: 'Minimum age of accompanied patron (optional)',
      minPatronHeightLabel: 'Minimum patron height (if applicable)',
    },
    boiler: {
      hazardLevelLabel: 'Hazard level',
      designPressureLabel: 'Design pressure',
      designTemperatureLabel: 'Design temperature',
      maxVolumeLabel: 'Maximum volume',
      outputUnitLabel: 'Output value',
      attendanceLabel: 'Attendance category',
    },
    buildingMaintenanceUnit: {
      safeWorkingLoadLabel: 'Designer’s Safe working load of the platform',
      maxWorkingHeightLabel: 'Maximum working height, at installation',
    },
    concretePlacingUnit: {
      concretePlacingUnitTypeLabel: 'Type of concrete placing boom',
      maxBoomLengthLabel: 'Designer’s maximum boom length',
    },
    escalator: {
      maxSpeedLabel: 'Designer’s rated speed',
      maxAngleLabel: 'Designer’s maximum angle of incline',
      maxTravelLabel: 'Travel',
      maxWidthLabel: 'Maximum width',
      maxPassengersLabel: 'Maximum number of passengers per hour',
    },
    lift: {
      driveSuspensionTypeLabel: 'Drive and suspension type',
      isMRLLiftLabel: 'Is this a Machine-Room-Less (MRL) Lift?',
      carriageTypeLabel: 'Carriage type',
      controlTypeLabel: 'Control type',
      maxSpeedLabel: 'Designer’s rated speed',
      operatingParamsLabel: 'Which operating parameters would you like to add?',
      maxRatedLoadLabel: 'Rated load',
      maxPassengersLabel: 'Maximum number of passengers',
      maxTravelLabel: 'Travel',
      forConstructionLabel: 'Is the lift intended to be used during construction activities?',
      inUncompliedConditionLabel:
        'Is the lift going to be operated in conditions which do not comply with its registered design?',
      additionalControlMeasureLabel: 'Please describe additional control measures',
      hasBeenInspectedLabel:
        'Has the lift has been inspected by a competent person with the above control measures in place and assessed by that person as being safe to operate?',
    },
    mobileCrane: {
      typeOfMobileCraneLabel: 'Type of mobile crane',
      otherTypeOfMobileCraneLabel: 'Other (please describe)',
      modelDetailsLabel: 'Carrier make and model details',
      maxRadiusLabel: 'Designer’s maximum radius',
      maxRatedCapacityLabel: 'Maximum rated capacity',
    },
    pressureVessel: {
      numberOfChambersLabel: 'How many chambers does the pressure vessel have?',
      hazardLevelLabel: 'Hazard level',
      volumeLabel: 'Volume',
      designPressureLabel: 'Design pressure',
      designTemperatureLabel: 'Design temperatures',
      minTemperatureSuffix: 'Min &deg;C',
      maxTemperatureSuffix: 'Max &deg;C',
      chamberContentsLabel: 'Please describe the chambers contents',
    },
    towerCrane: {
      typeOfTowerCraneLabel: 'Type of tower crane',
      maxRadiusLabel: 'Designer’s maximum radius',
      maxHeightLabel: 'Designer’s maximum height',
      maxRatedCapacityLabel: 'Maximum rated capacity',
      worksiteRegisteredLabel: 'Is the tower crane being registered to a worksite?',
    },
    inspectionDocumentUpload: {
      competentPersonLabel: 'Full name of competent person',
      inspectionDateLabel: 'Date of inspection',
      anySpecialConditionsLabel: 'Has the competent person applied any special conditions?',
      describeConditionsLabel: 'Please describe conditions as per the inspection certificate',
      supportingDocumentsLabel: 'Supporting document requirements',
    },
    towerCraneFoundationInspection: {
      competentPersonLabel: 'Full name of designer’s representative',
      inspectionDateLabel: 'Date design completed',
      anySpecialConditionsLabel: 'Has the designer’s representative applied any special conditions?',
      describeConditionsLabel: 'Please describe conditions as per the design statement',
      supportingDocumentsLabel: 'Supporting document requirements',
    },
  },
};
